/**
 * Shared CRM-style theme colors, aligned with the "Backoffice Rikutec — écrans" design canvas
 * and the RIKUTEC France brand (https://www.rikutec.fr/ — navy #092b4b, action blue #006eb5).
 * Import this instead of duplicating the object in every component.
 */
export const CRM_COLORS = {
    /** Theme CTA / interactive blue */
    primary: '#006eb5',
    /** Button hover / pressed */
    primaryDark: '#00598f',
    /** Lighter interactive blue (CTAs on site) */
    primaryLight: '#2889cd',
    /** Deep navy used for titles and the brand */
    secondary: '#092b4b',
    /** Sustainability / positive accent on site */
    success: '#11ba4e',
    warning: '#d39e00',
    error: '#c62828',
    info: '#006eb5',
    background: '#f4f7fa',
    surface: '#ffffff',
    /** Table heads, unfolded areas, card footers */
    surfaceMuted: '#f8fafc',
    /** Track of a segmented control */
    segmented: '#eef2f6',
    /** Selected line of a table */
    rowSelected: '#c7cdd4',
    text: {
        primary: '#0f2236',
        /** Form labels */
        label: '#3b4a5a',
        secondary: '#556372',
        disabled: '#95a0ab',
    },
    border: '#e3e8ee',
    /** Inputs and neutral buttons */
    borderStrong: '#cdd6e0',
    /** Separators inside a card */
    borderSoft: '#eef2f6',
    shadow: '0 1px 2px rgba(9, 43, 75, 0.04), 0 6px 18px rgba(9, 43, 75, 0.04)',
    shadowHover: '0 2px 4px rgba(9, 43, 75, 0.06), 0 10px 24px rgba(9, 43, 75, 0.08)',
    shadowPopover: '0 8px 28px rgba(9, 43, 75, 0.22)',
    shadowDialog: '0 16px 48px rgba(9, 43, 75, 0.28)',
    /** Background / text pairs of the status pills */
    status: {
        ok: { background: '#e3f5ea', color: '#0d7a3a' },
        wait: { background: '#fff3d6', color: '#8a5a00' },
        bad: { background: '#fde8e8', color: '#a12828' },
        neutral: { background: '#eef2f6', color: '#4b5866' },
        info: { background: '#e5f0fa', color: '#00598f' },
    },
    /** Selected entry of the side menu */
    navSelected: '#e9f6ee',
} as const;

/** Corner radii of the design: cards, dialogs and controls. */
export const CRM_RADIUS = {
    card: 14,
    dialog: 16,
    control: 8,
} as const;

/** Content width of a page. Its title band lines up with it. */
export const PAGE_MAX_WIDTH = 1392;
